// Module
var code = "<ul class=\"attribute-list\" ng-transclude></ul> ";
// Exports
module.exports = code;